import React from 'react';
export const MoonIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-134">
    <path d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83.14a10.306 10.306 0 00-4.8 8.9 10.33 10.33 0 0010.37 10.32 10.32 10.32 0 009.62-6.49c.53-1.13.16-1.64-.06-1.85-.22-.21-.69-.53-2.25.58z" data-id="element-135" />
  </svg>;
export const StarIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-136">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" data-id="element-137" />
  </svg>;
export const SparkleIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-138">
    <path d="M12 2C12 2 12.5 9.5 20 10C12.5 10.5 12 18 12 18C12 18 11.5 10.5 4 10C11.5 9.5 12 2 12 2Z" data-id="element-139" />
  </svg>;